import { CollectionLiveData } from '@components/collections/Model';
import { BaseApiParams } from '@services/Types';

export class AveragePriceChartResp {
  salesRecordsFound = false;
  marketAverage: BaseChartResp[] = [];
  retailerAverage: BaseChartResp[] = [];
}

export class BaseChartResp {
  period: string = '';
  value: number = 0;
}

export interface AverageSellingParam extends BaseApiParams, CollectionLiveData {
  saleType: string;
  isSummary: boolean;
}
